import { APP_ENV } from '~/constants/env'

export default defineNuxtRouteMiddleware(() => {
  const config = useRuntimeConfig()
  const headers = useRequestHeaders()

  //   Exit early if not in production environment
  if (config.public.APP_ENV !== APP_ENV.STG) {
    return
  }

  const incomingIp = headers?.['cf-connecting-ip']
  const incomingCountryCode = headers?.['cf-ipcountry']
  const rawIpWhiteList = config.IP_WHITELIST.split(',').map((ip) => ip.trim())

  // Exit early if required headers or configs are missing
  if (!rawIpWhiteList || !incomingIp) { return }

  // Process whitelist CIDR
  const isWhiteListIp = rawIpWhiteList.includes(incomingIp)

  // Bypass if the IP is in the whitelist
  if (!isWhiteListIp) {
    return createError({
      statusCode: 403,
      data: {
        incomingIp,
        incomingCountryCode
      }
    })
  }
})
